"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantCreditsContract = void 0;
const contract_1 = require("../base/contract");
const credits_schemas_1 = require("../../schemas/merchant/credits.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.MerchantCreditsContract = (0, contract_1.createContract)({
    name: 'MerchantCredits',
    baseUrl: '/merchants',
    version: '1',
    serviceModule: 'merchant',
    endpoints: {
        createDeposit: {
            method: 'POST',
            path: '/:merchantId/credits/deposit',
            body: credits_schemas_1.createDepositBodySchema,
            query: null,
            params: credits_schemas_1.createDepositParamsSchema,
            headers: null,
            response: {
                success: credits_schemas_1.createDepositResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'Record prepayment deposit',
                description: 'Records a customer prepayment, applies reward tier bonuses, and updates credit balance.',
                tags: ['Merchant', 'Credits', 'Prepayment'],
                deprecated: false,
            },
            tests: [
                'should record deposit and add to balance',
                'should apply tier bonus if selected',
                'should award coupons if tier includes them',
                'should return updated balance',
                'should return 404 for non-member user',
            ],
        },
        listDeposits: {
            method: 'GET',
            path: '/:merchantId/credits/deposits',
            body: null,
            query: credits_schemas_1.listDepositsQuerySchema,
            params: credits_schemas_1.listDepositsParamsSchema,
            headers: null,
            response: {
                success: credits_schemas_1.listDepositsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'List deposit history',
                description: 'Retrieves paginated deposit history with optional user and date filters.',
                tags: ['Merchant', 'Credits', 'History'],
                deprecated: false,
            },
            tests: [
                'should return paginated deposits',
                'should filter by user',
                'should filter by date range',
                'should include tier information',
            ],
        },
    },
});
